import { render, staticRenderFns } from "./DargainDetails.vue?vue&type=template&id=51d857e1&scoped=true&"
import script from "./DargainDetails.vue?vue&type=script&lang=js&"
export * from "./DargainDetails.vue?vue&type=script&lang=js&"
import style0 from "./DargainDetails.vue?vue&type=style&index=0&id=51d857e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d857e1",
  null
  
)

export default component.exports